<template>
  <div class="div-titulo-seccion">
    <p class="titulo-seccion-b">{{ titulo }}</p>
  </div>
</template>

<script lang="js">

export default {
  name: "TituloSeccion",
  props: {
      titulo: String
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/estilos/estilosgenerales.scss";

.div-titulo-seccion {
  border-bottom: 1px solid rgba(30, 33, 32, 1);
  height: 70px;
}
.titulo-seccion-b {
  padding: 25px;
  float: left;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.22em;
  color: rgba(105, 97, 88, 1);
}

/* TABLETAS */
@media all and (min-width: 768px) and (max-width: 1024px) {
}
/* CELULARES */
@media all and (max-width: 767px) {
  .titulo-seccion-b {
    padding: 13px !important;
  }
  .div-titulo-seccion {
    height: 50px !important;
  }
}
</style>
